<template>
  <div>
    Choose {{ props.maxChoices }} from the options below:
    <br />
    <br />
    <ul class="checkbox-list" data-test="cms-checklist">
      <li v-for="(data, index) in answers" :key="index">
        <input
          type="checkbox"
          :id="`checkbox-input-${index}`"
          v-model="inputs"
          :value="data.answerId"
          :disabled="inputs.length > props.maxChoices - 1 && inputs.indexOf(data.answerId) === -1"
          @change="inputHandler"
          :data-test="`cms-checkbox-${index}`"
        />
        <label
          class="checkbox-control"
          :class="{ 'disabled-text': disabledText(data.answerId) }"
          :data-test="`cms-checklist-label-${index}`"
          :for="`checkbox-input-${index}`"
        >
          {{ data.answerLabel }}
        </label>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import axios from "axios";
import { debug as d } from "debug";
import { computed, ref } from "vue";
import { SessionQuestionnaireApiModel } from "../../api-models";

const debug = d("cs.CmsChecklist");

export interface AnswerData {
  answerId: string;
  answerLabel: string;
}

const props = defineProps<{
  maxChoices: number;
  answers: AnswerData[];
  isShuffle: boolean;
  checklistId: string;
  questionnaire: SessionQuestionnaireApiModel;
}>();

const inputs = ref<string[]>(
  props.questionnaire.answers[props.checklistId]?.map((element) => {
    return element;
  }) || [],
);

function shuffleArray(array: AnswerData[]): AnswerData[] {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
}

const answers = computed(() => {
  return props.isShuffle ? shuffleArray(props.answers) : props.answers;
});

function disabledText(id: string): boolean {
  return inputs.value.length === props.maxChoices && !inputs.value.includes(id);
}

async function inputHandler(): Promise<void> {
  axios
    .patch(`/api/sessionquestionnaire/${props.questionnaire?.id}/answers`, {
      [props.checklistId]: inputs.value,
    })
    .then((resp) => {
      if (resp.status === 200) {
        debug("success!");
      }
    });
}
</script>

<style lang="less" scoped>
@import (reference) "../../styles/bootstrap/variables.less";

@form-font-color: #8f8f8f;

.checkbox-list {
  padding-left: 0;
  li {
    list-style-type: none;
    display: flex;
    align-items: center;
  }
}

.checkbox-control {
  font-weight: 100;
  font-size: 2rem;
  width: 50rem;
  margin: 1rem;
  transition: 0.2s;
}

input[type="checkbox"] {
  accent-color: @brand-primary;
  width: 2.5rem;
  height: 2.5rem;
  margin: 0;
  transition: 1s;
  cursor: pointer;
  @media (max-width: 450px) {
    width: 40px;
    height: 40px;
  }
}

.checkbox-control + .checkbox-control {
  margin-top: 1em;
}

input[type="checkbox"]:disabled {
  cursor: not-allowed;
  &:hover {
    outline: initial;
  }
}

.disabled-text {
  color: @practical-color;
}

.label-checkbox {
  padding-right: 4rem;
}

.disabled {
  opacity: 0.2;
  cursor: default;
  transition: 0.2s;
}
</style>
